var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/doubleArrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0557 12L5.99798 7.92701C5.85965 7.78851 5.78631 7.61701 5.77798 7.41251C5.76965 7.20801 5.84298 7.02818 5.99798 6.87301C6.14298 6.72818 6.31865 6.65576 6.52498 6.65576C6.73131 6.65576 6.90698 6.72818 7.05198 6.87301L11.5462 11.3673C11.6397 11.4609 11.7057 11.5597 11.7442 11.6635C11.7827 11.7673 11.802 11.8795 11.802 12C11.802 12.1205 11.7827 12.2327 11.7442 12.3365C11.7057 12.4403 11.6397 12.5391 11.5462 12.6328L7.05198 17.127C6.91348 17.2653 6.74198 17.3387 6.53748 17.347C6.33298 17.3553 6.15315 17.282 5.99798 17.127C5.85315 16.982 5.78073 16.8063 5.78073 16.6C5.78073 16.3937 5.85315 16.218 5.99798 16.073L10.0557 12ZM16.4057 12L12.348 7.92701C12.2096 7.78851 12.1363 7.61701 12.128 7.41251C12.1196 7.20801 12.193 7.02818 12.348 6.87301C12.493 6.72818 12.6686 6.65576 12.875 6.65576C13.0813 6.65576 13.257 6.72818 13.402 6.87301L17.896 11.3673C17.9896 11.4609 18.0557 11.5597 18.0942 11.6635C18.1327 11.7673 18.152 11.8795 18.152 12C18.152 12.1205 18.1327 12.2327 18.0942 12.3365C18.0557 12.4403 17.9896 12.5391 17.896 12.6328L13.402 17.127C13.2635 17.2653 13.092 17.3387 12.8875 17.347C12.683 17.3553 12.5031 17.282 12.348 17.127C12.2031 16.982 12.1307 16.8063 12.1307 16.6C12.1307 16.3937 12.2031 16.218 12.348 16.073L16.4057 12Z",
    fill: "#3F464C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.a10e319faedf340b291490d8df270042.svg";
export { ForwardRef as ReactComponent };